import { useContext } from "react";
import I18n from "../providers/I18nProvider/I18nContext";

export default function useTranslation() {
    return useContext(I18n);
}
